import React, { Component } from 'react';
import PropTypes from 'prop-types';
import memoize from 'memoize-one';
import { Switch, Route, Redirect } from 'react-router-dom';
import classNames from 'classnames';
import CreateApp from '../CreateApp';
import CreateCampaign from '../CreateCampaign';
import UploadMedia from '../UploadMedia';
import MediaUploadProposal from '../../components/MediaUploadProposal/MediaUploadProposal';
import AddPayment from '../../containers/AddPayment';
import LinkButton from '../../components/_atomic/LinkButton/LinkButton';
import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';
import Button from '../../components/_atomic/Button/Button';
import InfoModal from '../../components/_molecules/InfoModal/InfoModal';
import SideBar from '../../components/_molecules/SideBar/SideBar';
import SideBarItemList from '../../components/_molecules/SideBar/SideBarItemList/SideBarItemList';
import SquareButton from './components/SquareButton/SquareButton';
import HamburgerButton from './components/HamburgerButton/HamburgerButton';
import MediaLibraryScreen from '../MediaLibraryScreen';
import MainPanel from '../MainPanel';
import { PROFILE_STEP_STATUSES, USER_ROLES, publicHash } from '../../utils/constants';
import MediaLibraryButton from './components/MediaLibraryButton/MediaLibraryButton';
import UserScreen from '../UserScreen';
import RoundButton from '../../components/_atomic/RoundButton/RoundButton';
import mask from '../../components/_molecules/CurrencyField/assets/mask';
import BalanceScreen from '../BalanceScreen';
import { isActiveLink } from '../../utils/helpers';
import OverviewScreen from '../OverviewScreen';
import ClientsScreen from '../ClientsScreen';
import ClientsLogsScreen from '../ClientsLogsScreen';
import AdminUserScreen from '../AdminUserScreen';
import './Dashboard.scss';
import AdminAppsList from '../AdminAppsList';
import ImageButton from '../../components/_atomic/ImageButton/ImageButton';
import AdminsScreen from '../AdminsScreen/index';

const mainLogo = require('../../assets/images/Dashboard/logo.png');
const plusSign = require('./assets/plus-sign.svg');
const appsIcon = require('./assets/apps.png');
const clientsIcon = require('./assets/clients.png');
const overviewIcon = require('./assets/overview.png');
const adminsIcon = require('./assets/admin.svg');

const adminSideBarData = [
  {
    id: 'overview',
    label: 'Overview',
    img: overviewIcon,
  },
  {
    id: 'clients',
    label: 'Clients',
    img: clientsIcon,
  },
  {
    id: 'admins',
    label: 'Admins',
    img: adminsIcon,
  },
  {
    id: 'apps',
    label: 'Apps',
    img: appsIcon,
  },

];

const appListSideBarName = 'app-list';
const adminsSideBarName = 'admin-side-bar';


class Dashboard extends Component {
  static isPrivate = true;

  static propTypes = {
    logout: PropTypes.func.isRequired,
    getApps: PropTypes.func.isRequired,
    profile: PropTypes.shape({
      fullName: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
    match: PropTypes
      .shape({ url: PropTypes.string.isRequired })
      .isRequired,
    history: PropTypes
      .shape({
        push: PropTypes.func.isRequired,
        location: PropTypes
          .shape({ pathname: PropTypes.string.isRequired })
          .isRequired,
      })
      .isRequired,
    profileStepStatus: PropTypes.string.isRequired,
    apps: PropTypes
      .arrayOf(PropTypes.shape({}))
      .isRequired,
    balance: PropTypes.shape({ amount: PropTypes.number }).isRequired,
    sideBarChangeStatus: PropTypes.func.isRequired,
  };

  state = {
    showLogoutModal: false,
    sidebars: {
      [appListSideBarName]: {
        activeId: '',
      },
      [adminsSideBarName]: {
        activeId: '',
      },
    },
    isUser: false,
    isAdmin: false,
    sideBarOpen: true,
  }

  componentWillMount() {
    const { getApps, profile } = this.props;
    if (profile.role) {
      const isAdmin = profile.role === USER_ROLES.ADMIN;
      const isUser = profile.role === USER_ROLES.USER;
      this.setState(() => ({
        isUser,
        isAdmin,
      }));
      if (!isAdmin) {
        getApps({ projection: 'SHORT' });
      }
    }
  }


  componentDidUpdate(prevProps) {
    const {
      profile, apps,
    } = this.props;
    if (prevProps.profile.role !== profile.role) {
      const isAdmin = profile.role === USER_ROLES.ADMIN;
      const isUser = profile.role === USER_ROLES.USER;
      this.setState(() => ({
        isUser,
        isAdmin,
      }));
    }
    // doing this, cuz  need detect only first app loading
    if (prevProps.apps.length === 0 && apps.length > 0) {
      const sidebars = { ...this.state.sidebars };

      sidebars[appListSideBarName].activeId = apps[0].id;
      this.setState(() => ({
        sidebars,
      }));
    }
  }
  get userName() {
    return this.props.profile.fullName.split(' ')[0];
  }

  get userBalanceAmount() {
    return mask(this.props.balance.amount);
  }

  logoutUser = () => {
    this.props.logout();
  }

  showLogoutModal = () => {
    this.setState(() => ({ showLogoutModal: true }));
  }

  hideLogoutModal = () => {
    this.setState(() => ({ showLogoutModal: false }));
  }
  navigateToMedia = () => {
    this.props.history.push(`${publicHash}/app/media`);
  }
  navigateToApp = () => {
    this.props.history.push(`${publicHash}/app/add-new`);
  }
  navigateToMain = () => {
    const { isAdmin } = this.state;
    const { history, location } = this.props;
    if (isAdmin) {
      // alert('admin');
    } else if (location.pathname.indexOf('campaigns') === -1 && location.pathname.indexOf('edit') === -1) {
      history.push(`${publicHash}/app`);
    }
  }
  navigateToProfile = () => {
    this.props.history.push(`${publicHash}/app/me`);
  }
  navigateToBalance = () => {
    this.props.history.push(`${publicHash}/app/my-money`);
  }
  transformAppList = memoize(apps =>
    apps.map(app => ({ id: app.id, label: app.name, img: app.logo })));

  sideBarChangeHandler = ({ id, name }) => {
    const sidebars = { ...this.state.sidebars };
    const { isAdmin } = this.state;
    const { location } = this.props;
    const currentLoaction = location.pathname;
    const nextLocation = `/app/${id}/campaigns`;
    if (isAdmin) {
      sidebars[name].activeId = id;
      this.props.history.push(`${publicHash}/app/${id}`);
    } else if (currentLoaction !== nextLocation) {
      sidebars[name].activeId = id;
      if (name === appListSideBarName) {
        const { apps } = this.props;
        const selectedIndex = apps.findIndex(app => app.id === id);
        if (selectedIndex !== -1) {
          this.props.history.push(`${publicHash}/app/${id}/campaigns`);
        }
      }
      this.setState(() => ({
        sidebars,
      }));
    }
  }
  changeSideAppId = (id) => {
    const sidebars = { ...this.state.sidebars };
    if (sidebars[appListSideBarName].activeId !== id) {
      sidebars[appListSideBarName].activeId = id;
      this.setState(() => ({
        sidebars,
      }));
    }
  }
  changeAdminBarId = (id) => {
    const sidebars = { ...this.state.sidebars };
    if (sidebars[adminsSideBarName].activeId !== id) {
      sidebars[adminsSideBarName].activeId = id;
      this.setState(() => ({
        sidebars,
      }));
    }
  }
  toggleSideBar = () => {
    const { sideBarChangeStatus } = this.props;
    this.setState(({ sideBarOpen: prevSideBarOpen }) => ({
      sideBarOpen: !prevSideBarOpen,
    }));
    sideBarChangeStatus();
  }

  renderModalBody = (path) => {
    switch (path) {
      case ('/app/create-app'):
      {
        return 'You can continue creating of your first app next time';
      }
      case ('/app/create-campaign'):
      {
        return 'You can continue creating campaign for your app next time';
      }
      case ('/app/media-upload-proposal'):
      {
        return 'You can upload media later at dashboard';
      }
      case ('/app/media-upload'):
      {
        return 'You can upload media later at dashboard';
      }
      case ('/app/add-payment'):
      {
        return 'You can add payment method later';
      }
      default:
      {
        return 'You can continue from this place next time';
      }
    }
  }

  renderModalFooter = () => (
    <React.Fragment>
      <Button label="Log out" secondary clickHandler={this.logoutUser} />
      <Button label="Continue edit" clickHandler={this.hideLogoutModal} />
    </React.Fragment>
  )

  renderModal = visible => (
    <InfoModal visible={visible} footer={this.renderModalFooter()}>
      <div className="modal-header">
        <span>
          Are your sure you want to logout?
        </span>
      </div>
      <div className="modal-body">
        <span>{this.renderModalBody(this.props.history.location.pathname)}</span>
      </div>
    </InfoModal>
  )

  render() {
    const {
      match, history: {
        location,
      }, profileStepStatus, apps,
    } = this.props;

    const transformedApps = this.transformAppList(apps);
    const {
      showLogoutModal, isUser, sideBarOpen, isAdmin,
    } = this.state;
    const appListSideBar = this.state.sidebars[appListSideBarName];
    const adminsSideBar = this.state.sidebars[adminsSideBarName];
    const isFirstFlow = profileStepStatus !== PROFILE_STEP_STATUSES.OK;
    const dashboardClassNames = classNames({
      dashboard: true,
      'is-user': isUser,
      'is-admin': isAdmin,
      'is-first-flow': isFirstFlow,
      'side-bar-open': sideBarOpen && !isFirstFlow,
    });
    const balanceButtonWrapperClasses = classNames({
      'balance-button-wrapper': true,
      active: isActiveLink(location, 'my-money') || isActiveLink(location, 'update-payment'),
    });
    return (
      <div className={dashboardClassNames}>
        {this.renderModal(showLogoutModal)}
        <div className="dashboard-header">
          {!isFirstFlow && <HamburgerButton clickHandler={this.toggleSideBar} />}
          <div className="logo-wrapper"> {isFirstFlow ? <img src={mainLogo} alt="Main logo" /> : <ImageButton width={125} height={32} imgLink={mainLogo} clickHandler={this.navigateToMain} />}</div>
          {isFirstFlow && <ArrowButton onClick={this.showLogoutModal} />}

          {!isFirstFlow &&
          <React.Fragment>
            <div className="media-button-wrapper">
              <MediaLibraryButton clickHandler={this.navigateToMedia} />
            </div>
            {!isAdmin &&
            <div className={balanceButtonWrapperClasses}>
              <span>Balance: </span> <span className="balance">{this.userBalanceAmount}{' '} <span className="currency-sign">$</span> </span> <RoundButton onClick={this.navigateToBalance} radius="32px"><img src={plusSign} alt="+" /></RoundButton>
            </div> }
            <div className="user-name-wrapper">
              <LinkButton text={`Hello, ${this.userName}`} clickHandler={this.navigateToProfile} />
            </div>
          </React.Fragment> }
        </div>
        <div className="dashboard-wrapper">
          {!isFirstFlow &&
          <SideBar visible={sideBarOpen}>
            {isUser && (
            <React.Fragment>
              <SideBarItemList
                activeId={appListSideBar.activeId}
                changeHandler={this.sideBarChangeHandler}
                name={appListSideBarName}
                items={transformedApps}
              />
              <SquareButton clickHandler={this.navigateToApp} />
            </React.Fragment>) }
            {isAdmin &&
              <SideBarItemList
                className="admin-side-bar"
                activeId={adminsSideBar.activeId}
                changeHandler={this.sideBarChangeHandler}
                name={adminsSideBarName}
                items={adminSideBarData}
              />}
          </SideBar>}
          <Switch location={location}>

            {isAdmin && <Route path={`${match.url}/overview`} component={OverviewScreen} />}
            {isAdmin && <Route path={`${match.url}/clients`} component={ClientsScreen} />}
            {isAdmin && <Route path={`${match.url}/admins`} component={AdminsScreen} /> }
            {isAdmin && <Route path={`${match.url}/client/:clientId/logs`} component={ClientsLogsScreen} />}
            {isAdmin && <Route path={`${match.url}/client/:clientId`} component={AdminUserScreen} />}
            {isAdmin && <Route path={`${match.url}/apps/:userId?`} render={() => <AdminAppsList changeAdminBarId={this.changeAdminBarId} />} />}
            {isFirstFlow ? <Route path={`${match.url}/create-first-app`} render={() => <CreateApp isFirstFlow={isFirstFlow} />} /> : <Redirect exact from={`${match.url}/create-first-app`} to={`${match.url}`} />}
            {isFirstFlow ? <Route path={`${match.url}/create-first-campaign`} render={() => <CreateCampaign isFirstFlow={isFirstFlow} />} /> : <Redirect exact from={`${match.url}/create-first-campaign`} to={`${match.url}`} />}
            {isFirstFlow ? <Route
              path={`${match.url}/media-upload-proposal`}
              component={MediaUploadProposal}
            /> : <Redirect exact from={`${match.url}/media-upload-proposal`} to={`${match.url}`} />}
            {isFirstFlow ? <Route path={`${match.url}/media-upload`} component={UploadMedia} /> : <Redirect exact from={`${match.url}/media-upload`} to={`${match.url}`} />}
            {isFirstFlow ? <Route path={`${match.url}/add-payment`} render={() => <AddPayment isFirstFlow={isFirstFlow} />} /> : <Redirect exact from={`${match.url}/add-payment`} to={`${match.url}`} /> }
            {isFirstFlow ? <Route path={`${match.url}/refill`} render={() => <BalanceScreen />} /> : <Redirect exact from={`${match.url}/refill`} to={`${match.url}`} />}
            <Route path={`${publicHash}/app/add-new`} render={() => <CreateApp isFirstFlow={isFirstFlow} />} />
            <Route path={`${match.url}/update-payment`} render={() => <AddPayment isFirstFlow={false} />} />
            <Route path={`${match.url}/me`} render={() => <UserScreen />} />
            <Route path={`${match.url}/my-money`} render={() => <BalanceScreen />} />
            <Route path={`${match.url}/campaign/:appId/:campaignId?`} render={() => <CreateCampaign isFirstFlow={isFirstFlow} isAdmin={isAdmin} />} />
            <Route path={`${match.url}/media/:appId?/:campaignId?`} render={() => <MediaLibraryScreen isAdmin={isAdmin} />} />
            <Route path={`${match.url}/:appId?`} render={() => <MainPanel changeAdminBarId={this.changeAdminBarId} changeSideAppId={this.changeSideAppId} isAdmin={isAdmin} apps={apps} />} />

          </Switch>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js